@if (subscriptionData$ | async; as subscriptionData) {
  @if (subscriptionData.appSubscriptionState === appSubscriptionState.cancelled) {
    <nav class="navbar bg-danger text-white">
      <div class="mx-2">
        <i class="fa fa-exclamation me-2"></i>
        {{ 'customer_plan_contact_sales.plan_is_expired_or_canceled' | translate }}
        <a style="color: white; text-decoration: underline" routerLink="/settings/customer">{{
          'common.see_more_details' | translate
        }}</a>
      </div>
    </nav>
  }
  @if (subscriptionData.appSubscriptionState === appSubscriptionState.grace_period) {
    <nav class="navbar bg-warning text-dark">
      <div class="mx-2">
        <i class="fa fa-clock me-2"></i>
        {{
          'customer_plan_contact_sales.plan_is_in_grace_period'
            | translate: { gracePeriodEndDate: subscriptionData.gracePeriodEndDate | date: 'mediumDate' }
        }}
        <a class="text-dark" style="text-decoration: underline" routerLink="/settings/customer">{{
          'common.see_more_details' | translate
        }}</a>
      </div>
    </nav>
  }
}
@if (environmentKey && systemEnv$ | async; as systemEnv) {
  <nk-system-env-banner [systemEnv]="systemEnv"></nk-system-env-banner>
}
